interface FloorWithPlace {
  place?: { type?: string; rooms?: { pid: string }[] } | null;
}

/** The place of the floor holding `roomPid`, else the presence floor's (rooms load after type). */
export function findRoomFloorPlace<T extends FloorWithPlace>(
  floors: Record<string, T> | null | undefined,
  roomPid: string | null | undefined,
  presenceFloorPid?: string | null
): NonNullable<T['place']> | undefined {
  if (!floors) return undefined;
  if (roomPid) {
    for (const floor of Object.values(floors)) {
      if (floor.place?.rooms?.some((room) => room.pid === roomPid)) {
        return floor.place as NonNullable<T['place']>;
      }
    }
  }
  const presencePlace = presenceFloorPid ? floors[presenceFloorPid]?.place : undefined;
  return (presencePlace ?? undefined) as NonNullable<T['place']> | undefined;
}

/** Whether the floor the user is on is Webex; null while that floor can't be determined. */
export function isRoomFloorWebex(
  floors: Record<string, FloorWithPlace> | null | undefined,
  roomPid: string | null | undefined,
  presenceFloorPid?: string | null
): boolean | null {
  const place = findRoomFloorPlace(floors, roomPid, presenceFloorPid);
  return place ? place.type === 'webex' : null;
}
